export class SessionExpiredError extends Error {
    readonly name = 'SessionExpired';
    readonly message = 'Session expired';
}
